/** Maps locale code to the dealer's IANA timezone. */
const LOCALE_TIMEZONE_MAP: Record<string, string> = {
  pt: 'Europe/Lisbon',
  es: 'Europe/Madrid',
}

const DEFAULT_TIMEZONE = 'Europe/Madrid'

export function getDealerTimezone(locale: string): string {
  return LOCALE_TIMEZONE_MAP[locale] || DEFAULT_TIMEZONE
}
